import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './Banner.module.css';
import commonStrings from '../../resources/commonStrings';

const propTypes = {
  closeButtonFunc: PropTypes.func.isRequired,
  bannerShown: PropTypes.bool.isRequired,
};

/**
 * Banner component
 * @param closeButtonFunc Function: Updates state in MainContainer.jsx for removing banner in ui.
 * @param bannerShown Boolean: State updated by closeButtonFunc. Saves state of banner being closed by user.
 * @returns Banner component
 */
function Banner({ closeButtonFunc, bannerShown }) {
  return bannerShown ? (
    <div className={styles['banner']}>
      <div className={styles['flag']} />

      <div className={styles['banner-content']}>
        <h3 className={styles['banner-title']}>
          <strong>IMPORTANT:</strong> NWEA will retire most of the older legacy reports in the summer of 2024.
        </h3>
        <div className={`${styles['banner-message']} nwea-ds-v1-typography-body-copy-medium`}>
          <p>
            Learn more about how retiring these legacy reports will improve the reporting experience for MAP Growth in
            this NWEA Connection article:{' '}
            <a href="https://connection.nwea.org/s/nwea-news/legacy-report-retirement-summer-2024-MCWM6PIBQAIZCSJJTEYFJRSRVJU4?language=en_US">
              Legacy Report Retirement – summer 2024
            </a>
          </p>
        </div>
      </div>

      <button
        type="button"
        data-testid="banner-close-button"
        className={styles['close-button']}
        aria-label={commonStrings.banner.closeTooltip}
        onClick={() => closeButtonFunc(false)}
      >
        close
      </button>
    </div>
  ) : null;
}

Banner.propTypes = propTypes;

export default Banner;
